import { useState, useRef, useEffect } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

export default function CompletedOrderComponent({
  order,
  setSingleOrderToPay,
  handelPaymentModal,
  formatToMMDDYYYY,
  selectedOrders,
  handleSelectOrder,
  handleUpdateStatus,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [height, setHeight] = useState("0px");
  const [transactions, setTransactions] = useState({});
  const contentRef = useRef(null);

  // ✅ Expand/collapse animation
  useEffect(() => {
    if (isExpanded) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
  }, [isExpanded, transactions]);

  // ✅ Fetch transaction history when expanded
  useEffect(() => {
    const loadTransactionHistory = async () => {
      if (isExpanded && !transactions[order.COI_ID]) {
        try {
          const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/orders/get-transaction-history/${order.COI_ID}`
          );
          const data = await res.json();
          setTransactions((prev) => ({
            ...prev,
            [order.COI_ID]: data.transactions,
          }));
        } catch (error) {
          console.error("Failed to load transaction history:", error);
        }
      }
    };

    loadTransactionHistory();
  }, [isExpanded, order.COI_ID, transactions]);

  return (
    <>
      {" "}
      <div key={order.COI_ID} className="dp-item-wrapper">
        {/* Header Row
        <div className="checkbox-wrapper">
          <input
            type="checkbox"
            checked={selectedOrders.includes(order.COI_ID)}
            onChange={() => handleSelectOrder(order.COI_ID)}
          />
        </div> */}
        <div className="grid-image-wrapper">
          <img
            src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${order.PD_ID}/${order.PD_ProductPicPath[0]}`}
            alt={order.PD_Name}
          />
        </div>
        <div className="grid-order-details-wrapper">
          <div className="ord-prod-name">
            <span className="name">{order.PD_Name}</span>
            <span className="qty">x{order.COI_Quantity}</span>
          </div>
          <span>DATE ORDERED : {formatToMMDDYYYY(order.COI_Created_At)}</span>
          <span>ORDER NUMBER : {order.COI_Number}</span>
        </div>
        <div className="grid-order-status-wrapper">
          {order.COI_Status === "Shipped" ? (
            <span className="ord-prod-status" style={{ color: `#007d0c` }}>
              OUT FOR DELIVERY
            </span>
          ) : (
            <span className="ord-prod-status" style={{ color: `#007d0c` }}>
              DELIVERED
            </span>
          )}{" "}
          <span className="m-message">
            AMOUNT PAID : {order.COI_Downpayment}
          </span>
        </div>
        <div className="grid-message-wrapper">
          {order.COI_Status === "Shipped" ? (
            <span style={{ color: `#007d0c` }}>
              Your order has been shipped. It’s now on its way to you.
            </span>
          ) : (
            <span style={{ color: `#007d0c` }}>
              Your order has been delivered. Thank you for shopping with us!
            </span>
          )}{" "}
          <span
            className="m-link"
            style={{ cursor: "pointer" }}
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            View history {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
          </span>
        </div>
        <div className="grid-payment-wrapper">
          <div className="buttons-wrapper">
            {order.COI_Status === "Delivered" ? (
              <button
                className="pay-btn"
                onClick={() => {
                  handleUpdateStatus(order);
                }}
              >
                ORDER RECEIVED
              </button>
            ) : (
              ""
            )}
          </div>
        </div>{" "}
        {/* ✅ Expandable Section */}
        <div
          ref={contentRef}
          className="items-list"
          style={{
            maxHeight: height,
            overflow: "hidden",
            transition: "max-height 0.4s ease, opacity 0.3s ease",
            opacity: isExpanded ? 1 : 0,
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            marginTop: "10px",
            padding: isExpanded ? "10px 0px" : "0 0px",
          }}
        >
          {/* 👇 Transaction History UI */}
          <div className="history-content">
            <h4>Transaction History</h4>

            {transactions[order.COI_ID] ? (
              transactions[order.COI_ID].length > 0 ? (
                transactions[order.COI_ID].map((tx, idx) => (
                  <div key={idx} style={{ marginBottom: "10px" }}>
                    <p>
                      <strong>{formatToMMDDYYYY(tx.DatePurchase)}</strong> –{" "}
                      {tx.PaymentType} via {tx.PaymentMethod} – PHP{" "}
                      {tx.PaymentAmount}
                      <br />
                      Status: {tx.Status}
                      <br />
                      <a
                        href={`${process.env.REACT_APP_BASE_URL}Assets/purchase_order/${tx.TransactionID}/${tx.Receipt}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "blue",
                          cursor: "pointer",
                        }}
                      >
                        <span>VIEW RECEIPT</span>
                      </a>
                    </p>

                    <ul>
                      {tx.OrderItems.map((item, i) => {
                        const isHighlighted =
                          item.ProductID === order.PD_ID ||
                          item.ProductName === order.PD_Name;

                        return (
                          <li
                            key={i}
                            style={{
                              backgroundColor: isHighlighted
                                ? "gray"
                                : "transparent",
                              borderRadius: "5px",
                              padding: "4px 8px",
                              fontWeight: isHighlighted ? "600" : "normal",
                              transition: "background-color 0.3s ease",
                            }}
                          >
                            {item.ProductName} × {item.Quantity} @ PHP{" "}
                            {item.UnitPrice} = PHP {item.TotalAmount} —
                            Deposited: PHP {item.Deposited} Balance: PHP{" "}
                            {item.Balance}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ))
              ) : (
                <p>No transactions available.</p>
              )
            ) : (
              <p>Loading transaction history...</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
